import { useEffect, useMemo, useRef } from 'react';
import { relewiseTrackingService } from '../TrackingService';
import { relewiseMappingService } from '../MappingService';
import { ICartlinesViewProps } from '../../../modules/ext-cart/components/ext-cart-line-items';

const getCartSignature = (cartLines: ICartlinesViewProps[] | undefined) => {
    if (!cartLines) {
        return '';
    }
    return cartLines
        .map(({ data }) => `${data?.cartline.TotalAmount}-${data?.cartline.ItemId}-${data?.cartline.Quantity}`)
        .sort()
        .join('|');
};

export const useCartTracker = (
    subtotalAmount: number | undefined,
    cartLines: ICartlinesViewProps[] | undefined,
    isInitialized: boolean
) => {
    const currentSignature = useMemo(() => {
        return getCartSignature(cartLines);
    }, [cartLines]);

    const previousCartLinesSignatureRef = useRef<string>();
    const hasInitializedRef = useRef(false);

    useEffect(() => {
        const currency = window.___initialData___?.requestContext?.channel?.Currency;
        if (subtotalAmount === undefined || !currency || !isInitialized) {
            return;
        }

        // Initialize ref when it has been initialized
        if (!hasInitializedRef.current) {
            previousCartLinesSignatureRef.current = currentSignature;
            hasInitializedRef.current = true;
            return;
        }

        const hasCartChanged = currentSignature !== previousCartLinesSignatureRef.current;
        if (!hasCartChanged) {
            return;
        }

        const relewiseCart = relewiseMappingService.mapToRelewiseCart(subtotalAmount, cartLines, currency);
        relewiseTrackingService.trackCart(relewiseCart);
        previousCartLinesSignatureRef.current = currentSignature;
    }, [subtotalAmount, currentSignature]);
};
